import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-[#1E3A8A] via-[#1E40AF] to-[#3B82F6] text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Logo & Description */}
          <div className="sm:col-span-2 md:col-span-1">
            <button onClick={scrollToTop} className="text-2xl md:text-3xl font-bold mb-3 md:mb-4 cursor-pointer hover:opacity-80 transition-opacity">
              Boostio
            </button>
            <p className="text-white/80 text-sm leading-relaxed">
              Automaattinen Google-arvostelujen keräämispalvelu suomalaisille yrityksille.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-base md:text-lg mb-3 md:mb-4">Pikalinkit</h4>
            <ul className="space-y-2 md:space-y-3 text-sm">
              <li>
                <a href="#how-it-works" className="text-white/80 hover:text-white transition-colors cursor-pointer inline-block py-1">
                  Miten toimii
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-white/80 hover:text-white transition-colors cursor-pointer inline-block py-1">
                  Hinnat
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white/80 hover:text-white transition-colors cursor-pointer inline-block py-1">
                  UKK
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-base md:text-lg mb-3 md:mb-4">Yhteystiedot</h4>
            <ul className="space-y-2 md:space-y-3 text-sm">
              <li className="flex items-center gap-2 text-white/80 py-1">
                <i className="ri-mail-line"></i>
                <span>info@boostio.fi</span>
              </li>
              <li className="flex items-center gap-2 text-white/80 py-1">
                <i className="ri-phone-line"></i>
                <span>+358 44 32 31550</span>
              </li>
              <li className="flex items-center gap-2 text-white/80 py-1">
                <i className="ri-map-pin-line"></i>
                <span>Lahti, Suomi</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-base md:text-lg mb-3 md:mb-4">Juridiikka</h4>
            <ul className="space-y-2 md:space-y-3 text-sm">
              <li>
                <Link to="/terms" className="text-white/80 hover:text-white transition-colors cursor-pointer inline-block py-1">
                  Käyttöehdot &amp; Tietosuoja
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-sm text-center md:text-left">
          <p className="text-white/70">
            © {new Date().getFullYear()} Boostio. Kaikki oikeudet pidätetään.
          </p>
          <a 
            href="https://sivua.fi" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            Sivut By Sivua
          </a>
        </div>
      </div>
    </footer>
  );
}